import { List, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import ProfileDataCard from "./ProfileDataCard";

interface VoluntaryActivitesStudyProps {
  voluntaryStudy: string[];
}

/**
 * This component displays the voluntary activities/engagement in studies of an applicant.
 * @param voluntaryStudy The voluntary activities/engagement in studies
 * @returns The voluntary activities/engagement in studies of an applicant.
 */
const VoluntaryActivitesStudy = ({ voluntaryStudy }: VoluntaryActivitesStudyProps) => {
  return (
    <ProfileDataCard
      title={
        <>
          Ehrenamtliche Tätigkeiten/
          <br />
          Engagement im Studium
        </>
      }
    >
      <List
        disablePadding
        sx={{ listStyleType: "square", listStylePosition: "outside", pl: voluntaryStudy.length === 0 ? 0 : 2 }}
      >
        {voluntaryStudy.length === 0 ? (
          <Typography>Keine Angaben</Typography>
        ) : (
          voluntaryStudy.map((voluntaryStudy, index) => {
            return (
              <ListItem key={index} disablePadding sx={{ display: "list-item" }}>
                <ListItemText primary={voluntaryStudy} />
              </ListItem>
            );
          })
        )}
      </List>
    </ProfileDataCard>
  );
};

export default VoluntaryActivitesStudy;
